"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const deleteObject = (body, isBeCall) => __awaiter(void 0, void 0, void 0, function* () {
    let url = isBeCall
        ? 'http://tecma-digital-platform-int-bucket/v1/oci/object'
        : `${global.intBucketLibraryBaseUrl || ''}/bucketObject`;
    console.log('global.isDevMode', global.intBucketLibraryDevModeEnabled);
    if (global.intBucketLibraryDevModeEnabled) {
        url =
            'https://api-staging.tecmasolutions.com/biz-tecma-dev1/int-bucket/v1/oci/object';
    }
    const response = yield axios_1.default.delete(url, {
        withCredentials: true,
        data: body,
    });
    return response;
});
exports.default = deleteObject;
